export default __webpack_public_path__ + "static/media/burger.e1a1ebaf.svg";